export default "__VITE_ASSET__CwF9bKJQ__"